import { render, staticRenderFns } from "./AgeRating12.vue?vue&type=template&id=14f3652c"
import script from "./AgeRating12.vue?vue&type=script&lang=js"
export * from "./AgeRating12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports